import {FC} from 'react'
import {InputTextArea} from '../../InputV2'
type Props = {
  name: string
  textPlaceholder?: string
  disabled?: boolean
  Uppercase?: boolean
  maxLength?: number
  required?: boolean
  labelText?: string
}
const InputTextAreaWrapper: FC<Props> = ({
  name,
  disabled,
  textPlaceholder,
  Uppercase,
  maxLength,
  required,
  labelText,
}) => {
  let classLabel = required ? 'required' : ''
  return (
    <div>
      <label className={classLabel}>{labelText}:</label>
      <InputTextArea
        name={name}
        textPlaceholder={textPlaceholder}
        disabled={disabled}
        maxLength={maxLength}
        Uppercase={Uppercase}
      />
    </div>
  )
}

export default InputTextAreaWrapper
